import { OpenInNew } from '@mui/icons-material'
import { Button } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import BlockFullImage1Col from 'src/components/Common/BlockFullImage1Col'

export default function VirtualSummit() {
  return (
    <BlockFullImage1Col
      preTitle='virtualSummit.date'
      title={['virtualSummit.title']}
      subtitle={['virtualSummit.subtitle']}
      bgColor='#00010a'
      video='https://gemvision.com/Images/virtual_summit_banner_loop_video.mp4'
    >
      <Button
        size='large'
        variant='contained'
        href='https://events.bizzabo.com/747947'
        target='_blank'
        rel='noopener noreferrer'
        endIcon={<OpenInNew />}
        data-cy='home-banner-button'
      >
        <FormattedMessage id='common.registerNow' />
      </Button>
    </BlockFullImage1Col>
  )
}
